import { render, staticRenderFns } from "./LiveAction.vue?vue&type=template&id=38ccb18d&scoped=true"
import script from "./LiveAction.vue?vue&type=script&lang=js"
export * from "./LiveAction.vue?vue&type=script&lang=js"
import style0 from "./LiveAction.vue?vue&type=style&index=0&id=38ccb18d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ccb18d",
  null
  
)

export default component.exports